export default "/images/7beed18c0750b7d7273184fb9a08b55c.avif";